import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalService = inject(MsalService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    // Permettre l'accès à la page de test des notifications sans restriction
    // Vérifier l'URL complète depuis le Router
    const currentUrl = this.router.url;
    const fullPath = route.url.map(segment => segment.path).join('/');

    // Vérifier si on essaie d'accéder à notification-test
    if (currentUrl.includes('notification-test') || fullPath.includes('notification-test')) {
      return true;
    }

    if (currentUrl.includes('pca-dashboard') || fullPath.includes('pca-dashboard')) {
      return this.authService.isPcaOperator();
    }

    // Pour toutes les autres routes admin, vérifier les permissions
    try {
      const isAdmin = this.authService.isAdmin();
      if (!isAdmin) {
      }
      return isAdmin;
    } catch (error) {
      return false;
    }
  }

}
